import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0px;
  height: 100%;
  width: 9px;
`;

export const RightBorder = styled.div`
  border-right-style: solid;
  border-right-width: 6px;
  width: 100%;
  height: 100%;
  border-radius: 3px;
`;

export const BlueRightBorder = styled(RightBorder)`
  z-index: 19;
  border-right-color: ${({ theme }) => theme.COLORS.TERTIARY};
`;

export const OrangeRightBorder = styled(RightBorder)`
  z-index: 19;
  border-right-color: ${({ theme }) => theme.COLORS.WARNING};
`;
